export const TAB_STATES = {
  VIEW_REFUNDS: 'VIEW_REFUNDS',
  MANAGE_REFUNDS: 'MANAGE_REFUNDS',
}